import React, { useState } from "react";
import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

import { useAppDispatch } from "../../../redux/Hooks";
import { useDebounce } from "../../../components/custom-hook/useDebounce";
import { ReferralReasonsSliceActions } from "../../../redux/reducers/referral-reasons-slice";

import ReferralReasonListsStyles from "../ReferralReasonList.module.css";

const ReferralReasonListHeader = () => {
    const dispatch = useAppDispatch();

    const [searchTerm, setSearchTerm] = useState<string>("");

    const handleDebouncedSearch = useDebounce((term: string) => {
        dispatch(ReferralReasonsSliceActions.patchState({ searchTerm: term }));
    }, 2000);

    const handleSearchTerm = (term: string) => {
        setSearchTerm(term);
        dispatch(ReferralReasonsSliceActions.patchState({ currentPage: 0, pageSize: 10 }));
        handleDebouncedSearch(term);
    };

    const clearSearchTerm = () => {
        setSearchTerm("");
        dispatch(ReferralReasonsSliceActions.patchState({ searchTerm: null }));
    }

    const handleNewReferralReason = () => {
        dispatch(ReferralReasonsSliceActions.patchState({ openReferralReasonDialog: true }));
    }

    return (
        <Box className={`referalReasonWrap ${ReferralReasonListsStyles.search_panal}`}>
            <TextField
            className="referalSearch"
                value={searchTerm}
                onChange={(e) => handleSearchTerm(e.target.value)}
                sx={{ minWidth: '200px' }}
                variant="standard"
                placeholder='Search Referral Reasons'
                size='small'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position='start'>
                            <SearchIcon />
                        </InputAdornment>),
                    endAdornment: (
                        <InputAdornment position="end">
                            <CloseIcon sx={{ display: searchTerm ? "inline-block" : "none", fontSize: "22px" }} className={ReferralReasonListsStyles.closeIcon} onClick={clearSearchTerm} />
                        </InputAdornment>
                    )
                }}
            />
            <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleNewReferralReason}
                sx={{
                    padding: "6px 11px",
                    minWidth: "200px",
                    textTransform: "capitalize",
                    borderRadius: "100px",
                    marginLeft: "10px"
                }}
            >
                <Typography sx={{ textTransform: "capitalize", fontWeight: "500" }}>Add New Referral Reason</Typography>
            </Button>
        </Box>
    );
}

export default ReferralReasonListHeader